<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://atreshaghayegh.com" target="_blank">پنل شقایق  </a>
      <span class="ml-1"></span>
    </div>
    <div class="ml-auto">
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
